enum PlacementEnums {
    nav = 'Navigation',
    hero = 'Hero',
    footer = 'Footer',
    body = 'Body',
}

type PlacementType =
    | PlacementEnums.nav
    | PlacementEnums.hero
    | PlacementEnums.footer
    | PlacementEnums.body
    | undefined;

export { PlacementEnums, PlacementType };
